/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeStatsRequest
 */
export interface RuntimeStatsRequest {
    /**
     * 
     * @type {string}
     * @memberof RuntimeStatsRequest
     */
    id: string;
}

export function RuntimeStatsRequestFromJSON(json: any): RuntimeStatsRequest {
    return RuntimeStatsRequestFromJSONTyped(json, false);
}

export function RuntimeStatsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeStatsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function RuntimeStatsRequestToJSON(value?: RuntimeStatsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


